// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import {
  ContactRelationshipActions,
  ContactRelationshipActionTypes,
} from '../_actions/contact-relationship.actions';
// Models
import { ContactRelationshipModel } from '../_models/contact-relationship.model';
import { QueryParamsModel } from '../../_base/crud';

export interface ContactRelationshipsState extends EntityState<ContactRelationshipModel> {
  contactId: number;
  loading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedContactRelationshipId: number;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
  latestSuccessfullAction: any;
}

export const adapter: EntityAdapter<ContactRelationshipModel> =
  createEntityAdapter<ContactRelationshipModel>();

export const initialContactRelationshipsState: ContactRelationshipsState = adapter.getInitialState({
  loading: false,
  actionsloading: false,
  totalCount: 0,
  contactId: undefined,
  lastCreatedContactRelationshipId: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  latestSuccessfullAction: null,
  error: null,
});

export function contactRelationshipsReducer(
  state = initialContactRelationshipsState,
  action: ContactRelationshipActions,
): ContactRelationshipsState {
  switch (action.type) {
    case ContactRelationshipActionTypes.ContactRelationshipsPageToggleLoading:
      return {
        ...state,
        loading: action.payload.isLoading,
        lastCreatedContactRelationshipId: undefined,
      };
    case ContactRelationshipActionTypes.ContactRelationshipActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case ContactRelationshipActionTypes.ContactRelationshipOnServerCreated:
      return { ...state, loading: true };
    case ContactRelationshipActionTypes.ContactRelationshipCreated:
      return adapter.addOne(action.payload.contactRelationship, {
        ...state,
        lastCreatedContactRelationshipId: action.payload.contactRelationship.id,
      });
    case ContactRelationshipActionTypes.ContactRelationshipUpdated:
      return adapter.updateOne(action.payload.partialContactRelationship, state);
    case ContactRelationshipActionTypes.ContactRelationshipStoreUpdated:
      return adapter.updateOne(action.payload.contactRelationship, state);
    case ContactRelationshipActionTypes.OneContactRelationshipDeleted:
      return adapter.removeOne(action.payload.contactRelationship.id, state);
    case ContactRelationshipActionTypes.ContactRelationshipsPageCancelled:
      return {
        ...state,
        totalCount: 0,
        loading: false,
        contactId: undefined,
        lastQuery: new QueryParamsModel({}),
      };
    case ContactRelationshipActionTypes.ContactRelationshipsPageRequested:
      return {
        ...state,
        totalCount: 0,
        loading: true,
        contactId: action.payload.contactId,
        lastQuery: action.payload.page,
      };
    case ContactRelationshipActionTypes.ContactRelationshipsPageLoaded:
      return adapter.addMany(action.payload.contactRelationships, {
        ...initialContactRelationshipsState,
        totalCount: action.payload.totalCount,
        loading: false,
        contactId: state.contactId,
        lastQuery: state.lastQuery,
        showInitWaitingMessage: false,
      });
    case ContactRelationshipActionTypes.ThrowContactRelationshipError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        loading: false,
      };
    }
    case ContactRelationshipActionTypes.ClearContactRelationshipErrors: {
      return {
        ...state,
        error: null,
      };
    }
    case ContactRelationshipActionTypes.ClearContactRelationshipState: {
      return initialContactRelationshipsState;
    }
    default:
      return state;
  }
}

export const getContactRelationshipsState =
  createFeatureSelector<ContactRelationshipModel>('contactRelationships');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
